export const NAMESPACE = "TasksWidget";

export const TABS = {
  ASSIGNED_TO_ME: "assigned_to_me",
  DUE: "due",
  COMPLETED: "completed"
};
